module.exports = __webpack_public_path__ + "media/images/s03_03_en-46f25d7a0622a6e37725767983573af0.svg";